let readyPromise: Promise<typeof window.naver.maps> | null = null;

export function waitForNaverMaps(): Promise<typeof window.naver.maps> {
	if (typeof window === "undefined") {
		return Promise.reject(new Error("Window is not available"));
	}

	const w = window as any;

	if (w?.naver?.maps) {
		return Promise.resolve(w.naver.maps);
	}

	if (readyPromise) {
		return readyPromise;
	}

	readyPromise = new Promise((resolve, reject) => {
		const timeout = setTimeout(() => {
			reject(new Error("Naver Maps SDK load timeout"));
		}, 15000);

		const onReady = () => {
			clearTimeout(timeout);
			if (w?.naver?.maps) {
				resolve(w.naver.maps);
			} else {
				reject(new Error("Naver Maps SDK not available after initMap"));
			}
		};

		const prev = w.initMap;
		w.initMap = () => {
			try {
				if (typeof prev === "function") prev();
			} finally {
				onReady();
			}
		};

		// Race: if maps already present after wiring
		if (w?.naver?.maps) {
			clearTimeout(timeout);
			resolve(w.naver.maps);
		}
	});

	return readyPromise;
}
